import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { DcCoreElementType } from '../../core/dc-core-types';
import { AppMetadataEntity } from '../../ui/components/app-metadata/app-metadata.entity';
import { ProjectTraceListEntity } from '../components/project-home/project-trace-list.entity';
import { featureSelector, ProjectRootState } from './feature.store';
import { HomeSliceKey, HomeSliceState } from './home.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[HomeSliceKey]
);

const loadingSelector = createSelector(baseSelector, (state) => state.loading);
const metadataSelector = createSelector(
	baseSelector,
	(state) => state.metadata
);
const statSelector = createSelector(baseSelector, (state) => state.stat);
const elementSelector = createSelector(
	baseSelector,
	(state) => state.selectedElement
);

const permissionsSelector = createSelector(
	baseSelector,
	(state) => state.permissions
);

const tracesSelector = createSelector(baseSelector, (state) => state.traces);

@Injectable()
export class HomeSelector {
	public constructor(private readonly store: Store<ProjectRootState>) {}

	private get state(): Observable<HomeSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getLoading$(): Observable<boolean> {
		return this.store.pipe(select(loadingSelector));
	}
	public getProjectMetadata$(): Observable<AppMetadataEntity> {
		return this.store.pipe(select(metadataSelector));
	}

	public getProjectStat$(): Observable<Map<DcCoreElementType, number>> {
		return this.store.pipe(select(statSelector));
	}

	public getSelectedElement$(): Observable<DcCoreElementType> {
		return this.store.pipe(select(elementSelector));
	}

	public getTraces$(): Observable<ProjectTraceListEntity> {
		return this.store.pipe(select(tracesSelector));
	}

	public getCanEditProject$(): Observable<boolean> {
		return this.store.pipe(
			select(permissionsSelector),
			map((permissions) => permissions.edit)
		);
	}

	public getCanCreateElement$(): Observable<boolean> {
		return this.store.pipe(
			select(permissionsSelector),
			map((permissions) => permissions.create)
		);
	}
}
